import { Droplets } from 'lucide-react';
import { useAnimationLoop } from './useOnboardingAnim';
import { DemoTaskCard, DemoTaskTabs } from './e2eDemoComponents';
import { DEMO_ROOT_CLASS } from './onboardingLayout';

const TASKS_PHASES = [900, 1000, 1000, 1000, 1200];
const FLOW_CELLS = ['Vitals', 'Fluids', 'Meds'];

export default function TasksDemoAnimation() {
  const phase = useAnimationLoop(TASKS_PHASES);

  const showCompletedTab = phase >= 4;
  const manualDone = phase >= 3;
  const showFollowUp = phase >= 2;
  const highlightVoice = phase >= 1;

  return (
    <div className={DEMO_ROOT_CLASS}>
      <div className="flex h-full w-full flex-col justify-center px-1">
        <div className="space-y-1.5 rounded-xl bg-page p-2 shadow-sm">
        <DemoTaskTabs active={showCompletedTab ? 'completed' : 'pending'} />
        <DemoTaskCard
          iconKey="growth"
          title="Growth and Development Check"
          completed={manualDone}
          highlight={phase === 3}
        />
        <DemoTaskCard
          iconKey="vitals"
          title="Vitals"
          highlight={highlightVoice && !showCompletedTab}
          nestedItems={[
            {
              label: 'Blood Pressure',
              due: 'Due in 45m',
              completed: false,
              highlight: highlightVoice && !showCompletedTab,
            },
          ]}
        />
        {showFollowUp && (
          <div className="flex items-center gap-2 rounded-lg border border-purple-200 bg-purple-50 p-2 onboarding-fade-in">
            <span className="text-[8px] font-medium text-purple-700">Reassess pain in 2 hours</span>
          </div>
        )}
        <div className="rounded-lg border border-gray-200 bg-white p-2">
          <div className="mb-1 flex items-center gap-1 text-[9px] font-semibold text-primary">
            <Droplets className="h-3 w-3" />
            Flow Sheet
          </div>
          <div className="grid grid-cols-3 gap-0.5 text-[7px] text-gray-500">
            {FLOW_CELLS.map((cell, index) => (
              <span
                key={cell}
                className={`rounded p-1 text-center transition-all duration-300 ${
                  phase >= index ? 'bg-primary-light text-primary' : 'bg-gray-50'
                }`}
              >
                {cell}
              </span>
            ))}
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}
